import fnc from "@/helpers/func";
import routesNames from "@/router/constants";

export default {
    watch: {
        "filters.brands": {
            handler() {
                if (this.brands.length > 0) {
                    let bm = this.brand_model;
                    let remItem = [];
                    const brands = this.filters.brands.map(b => parseInt(b));

                    for (let k in this.filters.brand_model) {
                        let bmItem = this.findInArr(bm, this.filters.brand_model[k], true);

                        if (bmItem) {
                            //if (this.filters.brands.indexOf(bmItem.bid.toString()) >= 0) {
                            if (brands.indexOf(parseInt(bmItem.bid)) >= 0) {
                                remItem.push(bmItem.id);
                            }
                        }
                    }
                    this.filters.brand_model = remItem;
                }
            }
        },
        "filters.vt": {
            handler() {
                if (Object.keys(this.vehicle_type).length > 0) {
                    let flokkar = this.flokkar;
                    let remItem = [];

                    for (let k in this.filters.flokkar) {
                        let bmItem = this.findInArr(flokkar, this.filters.flokkar[k], true);

                        if (bmItem) {
                            if (this.filters.vt.indexOf(bmItem.vid.toString()) >= 0) {
                                remItem.push(bmItem.id);
                            }
                        }
                    }
                    this.filters.flokkar = remItem;
                }
            }
        },
        filters: {
            handler() {
                this.$store.state.selected_filters_count = this.addFilersName().length;
                if (this.load && this.issetUserFriendlyParams) {
                    return;
                }

                this.setUrl();
                this.$store.state.filter = this.filters;
                this.$store.state.carFilter = fnc.cleanFilters(this.filters);
                this.post(true);
                if (this.selectedFiltersCount == 0) {
                    this.getAd({
                        location: this.selectedFiltersCount ? this.searchResult : this.frontPage,
                        isUsed: 1
                    }).then(res => {
                        this.loadAd = true;
                        if (res && res.data && res.data.status) {
                            this.ad = res.data.ad;
                        }
                    });
                }
                if (this.mounted) {
                    // scroll.to(0)
                }
            },
            deep: true
        },
        $route() {
            this.filtered = this.getFiltered
            if (typeof this.$route != "undefined") {
                if (this.$route.path == "/tilbodsbilar") {
                    this.filters.verdtilbod = true;
                } else {
                    //this.filters.verdtilbod = false;
                }
                if (this.$route.fullPath == routesNames.oldCars) {
                    this.resetFilter(this.filters);
                }

                if (!this.load) {
                    this.resetFilter(this.filters);
                    this.loadUrlParams();
                    //this.getParams(this.filters);
                }

                this.showMenuPosition = null;
            }
        },
        carsLoaded: {
            immediate: true,
            handler() {
                this.scrolling()
            }
        },
        showMenu:{
            handler() {
                if(!this.showMenu && this.$device.mobile()){
                    this.insertAd(true);
                    this.mounted = true
                }
            }

}
    },
}